module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gd-Hc-Ia.686c03e6.png";